module.exports = __webpack_public_path__ + "vue_assets/img/img_header_vulcano.dff50d64.jpg";